import server from "@/api/server";

/**
 * @typedef {Object} Company
 * @property {string} inn
 * @property {string} dt_create
 * @property {string} ogrn
 * @property {string} okopf
 * @property {string} name
 * @property {string} address
 */

/**
 * @typedef {Object} CompanySearchResponse
 * @property {string} status - 'ok', 'err', 'redirect'
 * @property {Company[]} company - array of companies (fields: inn, dt_create, ogrn, okopf, name, address)
 */

/**
 * @param {string} q search query
 * @returns {Promise<CompanySearchResponse>}
 */
export async function searchCompany(q) {
  let res = await server.post("agent/agent/misc/search_company", { q });
  return res;
}

/**
 * @typedef {Object} Bank
 * @property {string} bic
 * @property {string} bank - Наименование банка
 */

/**
 * @typedef {Object} BankSearchResponse
 * @property {string} status - 'ok', 'err', 'redirect'
 * @property {Bank[]} results - array of banks (fields: bic, bank)
 */

/**
 * @param {string} q search query
 * @returns {Promise<BankSearchResponse>}
 */
export async function searchBank(q) {
  let res = await server.post("agent/agent/misc/search_bic", { q });
  return res;
}

/**
 * @typedef {Object} City
 * @property {string} city_name
 * @property {string} timeoffset_from_utc
 * @property {string} tz_id
 */

/**
 * @typedef {Object} CitySearchResponse
 * @property {string} status - 'ok', 'err', 'redirect'
 * @property {City[]} results
 */

/**
 * @param {string} q search query
 * @returns {Promise<CitySearchResponse>}
 */
export async function searchCity(q) {
  return await server.post("agent/agent/misc/search_city", { q });
}
